module.exports = __webpack_public_path__ + "static/media/the-amtico.9ef90f05.jpg";